define(function(require) {

	const ViewManager = require('civicsUtils/view_manager');
	const tpl = require('./templates/t_itv_activation_failed.hbs');

	return Marionette.ItemView.extend({
		template: tpl,
		tagName: 'div',
		className: 'activation-failed',
		events:{
			'click @ui.closeModalButton':'closeModal',
			'click @ui.returnLink':'returnUrl'
		},
		ui:{
			closeModalButton: '.bbm-btn-close',
			returnLink: '.return-link'
		},
		initialize: function(options) {
			this.modalRegion = options.modalContainer;
		},
		closeModal:function(){
			this.modalRegion.hideModal();
		},
		returnUrl: function(){
			window.location.href = "/";
		},
	});
});
